import { render, staticRenderFns } from "./HistoryUploader.vue?vue&type=template&id=3b4671b0&"
import script from "./HistoryUploader.vue?vue&type=script&lang=js&"
export * from "./HistoryUploader.vue?vue&type=script&lang=js&"
import style0 from "./HistoryUploader.vue?vue&type=style&index=0&id=3b4671b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports